





























helpers = require('../../helpers.coffee')

view_model = {
  data: ->
    current_user: Session.current_user
    count_tasks_data: {}
    loading: true

  methods:
    moment: -> moment()

    increaseTodayTasks: (task) ->
      Vue.set(@count_tasks_data, task.service, (@count_tasks_data[task.service] || 0) + 1)

    decreaseTodayTasks: (task) ->
      Vue.set(@count_tasks_data, task.service, (@count_tasks_data[task.service] || 0) - 1)

    loadCountTasksData: (filters={}) ->
      @reports_resource.countTasks(@loadCountTasksDataSuccess, @unkonwnError, params: {q: filters})

    loadCountTasksDataSuccess: (data) ->
      @count_tasks_data = data.body
      @loading = false

  computed:
    card_filters: ->
      filters = { period: @period, mode: 'due_on' }
      filters.user_id_eq = @current_user.id if @current_user.isSeller()
      filters
    
    calls_task: ->
      @count_tasks_data.find((task) -> task.type == 'ManualTasksServices::Phonecall').total
    
    email_task: ->
      @count_tasks_data.find((task) -> task.type == 'ManualTasksServices::Email').total

    linkedin_task: ->
      @count_tasks_data.find((task) -> task.type == 'ManualTasksServices::Linkedin').total

    social_task: ->
      @count_tasks_data.find((task) -> task.type == 'ManualTasksServices::Social').total

  created: ->
    @period = { from: @now, to: @now }
    @reports_resource = new ReportsResource(Session.current_company.id)
    @loadCountTasksData(@card_filters)
}

exports.default = helpers.vue_include(view_model, helpers.manual_tasks.list_wrapper, helpers.form, helpers.filters)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/manual_tasks/statistic_cards.vue